import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube, MapPin, Mail, Phone, Lock } from 'lucide-react';
import { toast } from 'sonner';
import { BRAND } from '../mock';

export default function Footer() {
  const submit = (e) => {
    e.preventDefault();
    toast.success('Terima kasih! Anda berlangganan newsletter PowerX.');
    e.currentTarget.reset();
  };

  return (
    <footer className="bg-neutral-950 text-neutral-300 mt-20">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
        <div className="lg:col-span-2 space-y-5">
          <div className="bg-white inline-block rounded-md p-2">
            <img src={BRAND.logoUrl} alt="PowerX" className="h-10" />
          </div>
          <p className="text-sm leading-relaxed max-w-md text-neutral-400">
            PowerX merupakan merek terpercaya dalam penyediaan solusi daya dan energi terbarukan di Indonesia. Kami menyediakan UPS, inverter, baterai, panel surya, sistem penerangan tenaga surya, serta berbagai produk pendukung lainnya.
          </p>
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2 max-w-md">
            <input
              type="email"
              required
              placeholder="Email Anda"
              className="flex-1 bg-neutral-900 border border-neutral-800 px-4 py-3 rounded-md text-sm outline-none focus:border-red-500"
            />
            <button className="bg-px-red hover:bg-red-700 text-white text-sm font-semibold px-6 py-3 rounded-md transition-colors">
              Berlangganan
            </button>
          </form>
          <div className="flex gap-3 pt-2">
            {[Facebook, Instagram, Linkedin, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-full border border-neutral-800 flex items-center justify-center hover:bg-px-red hover:border-red-500 transition-colors"
              >
                <Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Produk</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/products?category=ups&sub=online-lcd" className="hover:text-px-red">Online UPS</Link></li>
            <li><Link to="/products?category=ups&sub=line-interactive-lcd" className="hover:text-px-red">Line Interactive UPS</Link></li>
            <li><Link to="/products?category=inverter&sub=inverter-hybrid" className="hover:text-px-red">Inverter Hybrid</Link></li>
            <li><Link to="/products?category=battery&sub=battery-lifepo4-rack" className="hover:text-px-red">Baterai LiFePO4</Link></li>
            <li><Link to="/products" className="hover:text-px-red">Semua Produk</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Perusahaan</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/about" className="hover:text-px-red">Tentang Kami</Link></li>
            <li><a href="#" className="hover:text-px-red">Karir</a></li>
            <li><a href="#" className="hover:text-px-red">Distributor</a></li>
            <li><Link to="/articles" className="hover:text-px-red">Berita & Artikel</Link></li>
            <li><Link to="/contact" className="hover:text-px-red">Service Center</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-4">Kontak</h4>
          <ul className="space-y-4 text-sm">
            <li>
              <p className="text-white font-semibold mb-1">Jakarta</p>
              <div className="flex gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-px-red flex-shrink-0" />
                <span>
                  Menara Jakarta Tower Fortune 12F, Kemayoran, Jakarta — Indonesia
                </span>
              </div>
            </li>
            <li>
              <p className="text-white font-semibold mb-1">Surabaya</p>
              <div className="flex gap-2">
                <MapPin className="w-4 h-4 mt-0.5 text-px-red flex-shrink-0" />
                <span>
                  Jl. Dukuh Kupang Barat I No.180-182, Dukuh Pakis, Surabaya — Jawa Timur, Indonesia
                </span>
              </div>
            </li>
            <li className="flex gap-2">
              <Phone className="w-4 h-4 mt-0.5 text-px-red flex-shrink-0" />
              <span>+62 21 5050 8800</span>
            </li>
            <li className="flex gap-2">
              <Mail className="w-4 h-4 mt-0.5 text-px-red flex-shrink-0" />
              <span>support@i-powerx.com</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-neutral-900">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-5 flex flex-col md:flex-row justify-between text-xs text-neutral-500 gap-2">
          <p>© {new Date().getFullYear()} PT PowerX Indonesia. Semua hak dilindungi.</p>
          <div className="flex flex-wrap items-center gap-5">
            <a href="#" className="hover:text-white">Kebijakan Privasi</a>
            <a href="#" className="hover:text-white">Syarat & Ketentuan</a>
            <a href="#" className="hover:text-white">Garansi</a>
            <Link
              to="/akses-data"
              data-testid="footer-access-data-btn"
              className="inline-flex items-center gap-1.5 text-neutral-500 border border-neutral-700 rounded-full px-3 py-1 hover:text-white hover:border-neutral-500 transition-colors"
              title="Khusus tim sales PowerX"
            >
              <Lock className="w-3 h-3" /> Akses Data
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
